import { TargetAudience } from "../../../types";

export const getTargetAudienceLabel = (val: TargetAudience) => {
  switch (val) {
    case "beginner":
      return "入门";
    case "intermediate":
      return "进阶";
    case "advanced":
      return "高级";
    default:
      return "-";
  }
};
